"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconStyles = void 0;

var _styles = require("@material-ui/core/styles");

var withColor = function withColor(props, theme) {
  return props.color || theme.palette.text.primary;
};

var useIconStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    withColor: {
      '& > span': {
        color: function color(props) {
          return withColor(props, theme);
        }
      },
      '& > svg': {
        fill: function fill(props) {
          return withColor(props, theme);
        }
      }
    },
    small: {
      width: 24,
      height: 24,
      '& > svg': {
        width: 24,
        height: 24
      }
    },
    medium: {
      width: 36,
      height: 36,
      '& > svg': {
        width: 36,
        height: 36
      }
    },
    large: {
      width: 48,
      height: 48,
      '& > svg': {
        width: 48,
        height: 48
      }
    }
  };
});
exports.useIconStyles = useIconStyles;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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